export default __webpack_public_path__ + "static/media/Icon_vedi.08f492bc.svg";